import React from 'react';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { Carousel as AntCarousel, Row, Col, Space } from 'antd';
import TweenOne from 'rc-tween-one';
import Children from 'rc-tween-one/lib/plugin/ChildrenPlugin';
import { Content1DataSource } from '../data';
import { JumboTabs, Card } from 'antd-mobile';

TweenOne.plugins.push(Children);

class Content1 extends React.PureComponent {
  constructor(props) {
    super(props);
    this.carouselRef = React.createRef();
    this.state = {
      current: 0,
    };
  }

  onTitleClick = (_, i) => {
    const carouselRef = this.carouselRef.current.childRefs.carousel;
    carouselRef.goTo(i);
  };

  onBeforeChange = (_, newIndex) => {
    this.setState({
      current: newIndex,
    });
  };


  getChildrenToRender = (dataSource) => {
    const { current } = this.state;
    const { Carousel } = dataSource;
    const {
      titleWrapper,
      children: childWrapper,
      wrapper,
      ...carouselProps
    } = Carousel;

    const {
      barWrapper,
      title: titleChild,
      ...titleWrapperProps
    } = titleWrapper;
    const titleToRender = [];
    const childrenToRender = childWrapper.map((item, ii) => {
      const { title, children, className } = item;
      titleToRender.push(
        <Col
          span={4}
          {...title}
          key={ii.toString()}
          onClick={(e) => {
            this.onTitleClick(e, ii);
          }}
          className={
            ii === current ? `${title.className || ''} active` : title.className
          }
        >
          {title.children}
        </Col>
      );
      const childrenItem = children.map(($item, i) => {
        const { title, list, className: clname, icon } = $item;
        return (
          <Col span={11} offset={1} className={clname} key={i.toString()}>
            <div className={title.className}>{title.children}</div>
            <Space style={{ marginTop: "40px" }} size={120 / list.length} direction="vertical">{list.map((c, j) => <div className='content1-list-li'><img alt='apexDB product feature' src={icon}></img>{c.text}</div>)}</Space>
          </Col>
        );
      });
      return (
        <div key={ii.toString()}>
          <img alt="apexDB product feature background" width={1200} className="content1-item-bg" src={item.backgroundImg} />
          <QueueAnim type="bottom" component={Row} className={className}>
            {childrenItem}
          </QueueAnim>
        </div>
      );
    });

    const width = [0,'27%','56%','calc(100% - 180px)'];
    return (
      <QueueAnim
        key="queue"
        leaveReverse
        type="bottom"
        delay={[0, 100]}
        {...wrapper}
        ref={this.carouselRef}
      >
        <div {...titleWrapperProps} key="title">
          <div {...titleChild}>
            <Row gutter={30} justify="space-between" style={{ width: 1200 }} >
              {titleToRender}
            </Row>
            <div
              {...barWrapper}
              style={{
                left: width[current],
              }}
            >
              <em {...barWrapper.children} />
            </div>
          </div>
        </div>
        <AntCarousel
          {...carouselProps}
          key="carousel"
          infinite={false}
          beforeChange={this.onBeforeChange}
        >
          {childrenToRender}
        </AntCarousel>
      </QueueAnim>
    );
  };


  getChildrenToRenderMobile = (dataSource) => {
    const { Carousel } = dataSource;
    const {
      children: childWrapper,
    } = Carousel;
    return (
      <JumboTabs>
        {childWrapper.map((item, ii) => {
          return <JumboTabs.Tab title={item.title.children} key={ii}>
            {item.children.map((c, i) => {
              return <Card className={c.className} key={i} title={c.title.children}>{
                c.list.map((l, t) => {
                  return <div className='content1-list-li'>{l.text}</div>;
                })}</Card>;
            })}
          </JumboTabs.Tab>
        })}
      </JumboTabs>
    )

  }
  render() {
    const { isMobile, ...props } = this.props;
    const dataSource = Content1DataSource;
    return (
      <div {...props} {...dataSource.wrapper}>
        <div>
          <OverPack {...dataSource.OverPack}>
            {isMobile ?this.getChildrenToRenderMobile(dataSource): this.getChildrenToRender(dataSource)}
          </OverPack>
        </div>
      </div>
    );
  }
}
export default Content1;
